var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmallLogoPresentation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#00BCDA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0001,
    cy: 16.0011,
    r: 11.7714,
    stroke: "#00BCDA",
    strokeWidth: 1.14286
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8594 14.434C18.8594 15.9841 17.6028 17.2407 16.0527 17.2407C14.5026 17.2407 13.246 15.9841 13.246 14.434C13.246 12.884 14.5026 11.6274 16.0527 11.6274C17.6028 11.6274 18.8594 12.884 18.8594 14.434Z",
    stroke: "#00BCDA",
    strokeWidth: 1.1102
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5224 18.917L13.5208 18.9159C12.3457 18.1521 11.6426 17.0129 11.4051 15.6031L11.3271 15.1402H10.8577H8.27881H7.69732L7.7243 15.7211C7.83417 18.0862 9.35103 20.9924 12.2297 22.4287L12.2297 22.4287L12.233 22.4303C15.2532 23.9124 18.2692 23.6937 21.0227 21.7158C23.0123 20.2912 24.0849 18.2814 24.3729 15.8521L24.4465 15.2317H23.8217H21.2374H20.7782L20.6921 15.6827C20.4466 16.9692 19.8538 17.8714 19.0853 18.4679C18.3133 19.0671 17.33 19.3837 16.2681 19.4328C15.1875 19.4271 14.2546 19.3967 13.5224 18.917Z",
    stroke: "#00BCDA",
    strokeWidth: 1.1102
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmallLogoPresentation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/small-logo-presentation.ac5c14dca9496cf19069ee5bc6cdbfae.svg";